
define('text!views/shop/online/online_preview.html',[],function () { return '<ul id="shop-online-list-container" class="slider-list"></ul>';});

